/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConvertibleNoteModel } from './ConvertibleNoteModel';
import type { LiqPrefLedgerConfig } from './LiqPrefLedgerConfig';
import type { WritableDividendRateLedgerItem } from './WritableDividendRateLedgerItem';
export type ProFormaSecurityModel = {
  id?: number | null;
  cap_table?: number | null;
  convertible_notes?: Array<ConvertibleNoteModel> | null;
  liquidation_preference_ledger_config?: LiqPrefLedgerConfig;
  dividend_rate_ledger_items?: Array<WritableDividendRateLedgerItem>;
  readonly created_at?: string;
  readonly updated_at?: string;
  name: string;
  /**
   * Official legal security name; `name` is its display alias
   */
  legal_name?: string | null;
  readonly last_audit_event_id?: string | null;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  /**
   * ID from external system to correlate with (e.g. iLevel security)
   */
  external_id?: string | null;
  investment_date?: string | null;
  issue_price?: string | null;
  shares_outstanding?: string | null;
  conversion_rate?: string | null;
  pik_shares?: string | null;
  shares_diluted?: string | null;
  current_own_percent?: string | null;
  diluted_own_percent?: string | null;
  strike_price?: string | null;
  liquidation_preference?: string | null;
  seniority?: number | null;
  is_participating?: boolean | null;
  is_participation_cap?: boolean | null;
  participation_cap?: string | null;
  has_dividends?: boolean | null;
  has_multiple_investments?: boolean | null;
  dividend_payment_type?: ProFormaSecurityModel.dividend_payment_type | null;
  dividend_rate?: string | null;
  has_compounding?: boolean | null;
  compounding_period?: number | null;
  accrued_dividends?: string | null;
  initial_liquidation_pref?: string | null;
  total_preference?: string | null;
  multiple_investments?: any;
  order?: number | null;
  options_ledger?: any;
  security_ref?: string | null;
  underlying_security_ref?: string | null;
  security_group_ref?: string | null;
  is_hidden?: boolean | null;
  total_note_preference?: string | null;
  total_note_value_at_md?: string | null;
  security_type?: number | null;
  underlying_security?: number | null;
};
export namespace ProFormaSecurityModel {
  export enum dividend_payment_type {
    '_0' = 0,
    '_1' = 1,
  }
}

